import React from "react"
import { Link } from "gatsby"
import { useInView } from "react-intersection-observer"

import Layout from "../../components/layout"
import Header from "../../components/header"
import Projects from "../../components/projects"

const Fifa = () => {
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  })

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <Layout>
      <Header />
      <div className="project">
        <div className="container-fluid subheader">
          <div className="row">
            <div className="col-lg-4">
              <h2>02. Fifa Museum</h2>
            </div>
            <div className="offset-lg-1 col-lg-3">
              <h2>2020</h2>
            </div>
            <div className="col-lg-4">
              <h2>Identity, Typeface Design</h2>
            </div>
          </div>
        </div>
        <div className="container-fluid p-0">
          <div className="row no-gutters">
            <div className="col-12 hero hero-fmuseum">
              <div className={`hero-footer ${inView}`}>
                <div className="row justify-content-between">
                  <div className="col-lg-5 d-none d-md-block">
                    <h2>
                      <Link to="/projects/fifa">Next Project(01) ↖</Link>
                    </h2>
                    <h2>
                      <Link to="/projects/sueños">Next Project(03) ↗</Link>
                    </h2>
                  </div>
                  <div className="col-md-3 d-none d-md-block">
                    <h2>
                      <Link to="/">rg-rq.com</Link>
                    </h2>
                  </div>
                  <div className="offset-md-2 col-md-2">
                    <button onClick={scrollTop}>
                      <h2>
                        Back up
                        {inView ? (
                          <img
                            className="img-fluid"
                            src="/Up.svg"
                            alt="cheveron icon"
                          />
                        ) : (
                          <img
                            className="img-fluid"
                            src="/Up-white.svg"
                            alt="cheveron icon"
                          />
                        )}
                      </h2>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid content">
          <div className="row text-section">
            <div className="col-lg-5">
              <p>FIFA MUSEUM </p>
            </div>
            <div className="col-lg-7">
              <p>
                Fifa Museum is focused on supporting representation and its
                community. Many of their programs represent this including an
                exhibition dedicated to the US Women’s National team in
                celebration of their accomplishments. The museum also provides a
                space for education and play.
              </p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/01_zk7byf.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <div className="embed-responsive embed-responsive-16by9">
                <video
                  className="embed-responsive-item"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source
                    src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/static/fmuseum/02_f5zcpn.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/03_qd8xsz.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/04_umzr1h.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/05_wscyio.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/06_xunssh.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <div className="embed-responsive embed-responsive-16by9">
                <video
                  className="embed-responsive-item"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source
                    src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/static/fmuseum/08_dlyadv.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
            <div className="col-12">
              <div className="embed-responsive embed-responsive-16by9">
                <video
                  className="embed-responsive-item"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source
                    src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/static/fmuseum/09_ugwmpc.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/10_ubeuxo.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/11_csnmjx.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/12_bm2qej.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/13_mn8flr.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/14_xxthb0.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/15_e7eyh5.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/16_yzcs99.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/17_hmkwac.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/18_qztikv.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/19_vudbws.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/20_hulhga.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/21_wdjkh4.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/22_oqi18x.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/23_dlny0d.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/24_fqxbbx.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/25_d1s4rf.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/fmuseum/26_mqwwms.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <div className="embed-responsive embed-responsive-16by9">
                <video
                  className="embed-responsive-item"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source
                    src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/static/fmuseum/27_j2a2vj.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          </div>
          <div className="row text-section">
            <div className="col-lg-5">
              <p>Special Thank You</p>
            </div>
            <div className="col-lg-7">
              <p>Brad Bartlett (Professor)</p>
              <p>Sharon Park (TA)</p>
              <p>Chris Taylor (TA)</p>
              <p>Cristopher Gonzalez</p>
              <p>Mazzie Miles (Professor)</p>
              <p>Ivan Cruz (Professor)</p>
              <p>Mario Ascencio</p>
            </div>
          </div>
        </div>
      </div>
      <div ref={ref}></div>
      <Projects />
    </Layout>
  )
}
export default Fifa
